import BaseDialog from '@components/shared/Dialog/BaseDialog';
import { Stack, TextField } from '@mui/material';
import { debounce } from 'lodash';
import { ComponentProps } from 'react';
import { SubdimensionDictionary } from './LciReportSetupForm';
import { NameValuePair } from './DimensionSelector';

export type SubdimensionsDialogProps = {
  subdimensions: NameValuePair[];
  dimensionName: string;
  setSubdimensionDictionary: (originalName: string, newName: string) => void;
  subdimensionDictionary: SubdimensionDictionary;
  onClose: ComponentProps<typeof BaseDialog>['onClose'];
  open: ComponentProps<typeof BaseDialog>['open'];
};

const DEBOUNCE_WAIT_TIME = 250;

export const SubdimensionsDialog = (props: SubdimensionsDialogProps) => {
  const handleChange = debounce(
    (originalName: string, newName: string) =>
      props.setSubdimensionDictionary(originalName, newName),
    DEBOUNCE_WAIT_TIME
  );

  return (
    <BaseDialog
      title={`Edit ${props.dimensionName} Subdimension Names`}
      open={props.open}
      onClose={props.onClose}
    >
      <Stack spacing={2}>
        {props.subdimensions.map(subdimension => (
          <TextField
            key={subdimension.value}
            label={subdimension.value}
            defaultValue={
              props.subdimensionDictionary[subdimension.value] ??
              subdimension.value
            }
            onChange={e => handleChange(subdimension.value, e.target.value)}
          />
        ))}
      </Stack>
    </BaseDialog>
  );
};
